import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';

declare var RDStationForms: any;

@Component({
  selector: 'app-vitrine',
  templateUrl: './vitrine.component.html',
  styleUrls: ['./vitrine.component.css']
})
export class VitrineComponent implements OnInit {

  public areasConhecimento: any[] = [];

  constructor(public dataService: DataService) {
  }

  async ngOnInit() {
    new RDStationForms('aditt-vitrine-tecnologica-todas-98e6fcef536a18df9018', 'UA-2727336-2').createForm();

    this.areasConhecimento = (await this.dataService.getData()).areasConhecimento;
  }

}
